import { useTranslation } from 'react-i18next'
import * as z from 'zod'

export const useCreateNewPasswordSchema = () => {
  const { t } = useTranslation()

  const createNewPasswordSchema = z
    .object({
      currentPassword: z.string(),
      newPassword: z.string(),
      confirmNewPassword: z.string(),
    })
    .refine((values) => values.newPassword === values.confirmNewPassword, {
      message: t('screens:signup.noMatch'),
      path: ['confirmNewPassword'],
    })

  return createNewPasswordSchema
}

export type ICreateNewPasswordSchema = z.infer<
  ReturnType<typeof useCreateNewPasswordSchema>
>
